import { useState, useEffect } from "react";
import { getLiveByFounderType } from "../../network/lib/founder.js";
import { getFounderTypes } from "../../network/lib/masterData.js";
import { showHideLoader } from "../utils/helper.js";

function FounderDetails() {
  const [founderDetails, setFounderDetails] = useState();
  const [founderTypes, setFounderTypes] = useState();
  const [selectedValue, setSelectedValue] = useState("1");

  useEffect(() => {
    !founderTypes && populateFounderTypes();
    !founderDetails && populateFounderDetails(1);
  }, []);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    populateFounderDetails(event.target.value);
  };

  function populateFounderTypes() {
    getFounderTypes().then((res) => {
      if (res.status == 200) {
        setFounderTypes(res.data);
      }
    });
  }

  function populateFounderDetails(mfIf) {
    showHideLoader(true);

    getLiveByFounderType(mfIf).then((res) => {
      if (res.status == 200) {
        setFounderDetails(res.data);
        showHideLoader();
      }
    });
  }

  const types = founderTypes && (
    <select onChange={handleChange} value={selectedValue}>
      <option value="0">Select</option>
      {founderTypes.map((x) => (
        <option key={x.id} value={x.id}>
          {x.name}
        </option>
      ))}
    </select>
  );

  const contents = founderDetails && (
    < div style={{ textAlign: "left",  border: '3px solid #fe6902', borderRadius: '40px', padding:"10px 25px" }}>
      <div className="Row">
        <div className="Cell">
          <div className="Table">
            <div className="Row">
              <div className="Cell" style={{ fontWeight: 'bold' }}>मंडळ संस्थापक प्रकार : </div>
              <div className="Cell">{types}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="Row">
        <div className="Cell">
          <div className="profile-main">
            {founderDetails.map((founderDetail) => (
              <div className="profile-listing">
                <div className="profile-image" >
                  {founderDetail.image && (
                    <img
                      id="img"
                      src={founderDetail.image}
                      style={{ height: "80px", width: "80px",border: '1px solid',borderRadius: '10px', }}
                    />
                  )}
                </div>
                <div>
                  <h2>{founderDetail.title}</h2>
                  {founderDetail.description && (
                    <div className="profile-post">
                      <span>पद: </span>
                      {founderDetail.description}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  return contents;
}

export default FounderDetails;
